import { createFileRoute, useNavigate } from "@tanstack/react-router";
import CardFinder, { emptyAnswers, type FinderAnswers } from "@/pages/CardFinder";

const TITLE = "Kreditkarten-Finder 2026 – in 5 Fragen zur passenden Karte";
const DESCRIPTION =
  "Kostenloser Kreditkarten-Finder: fünf kurze Fragen zu Nutzung, Gebühren, Girokonto und SCHUFA — als Ergebnis die drei passenden Karten mit Begründung.";
const URL = "https://www.kreditkarten.de/tools/kreditkarten-finder";

const str = (value: unknown) => (typeof value === "string" ? value : "");

export const Route = createFileRoute("/tools/kreditkarten-finder")({
  validateSearch: (search: Record<string, unknown>): FinderAnswers => ({
    zweck: str(search.zweck),
    wichtig: str(search.wichtig),
    konto: str(search.konto),
    typ: str(search.typ),
    schufa: str(search.schufa),
  }),
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: FinderRoute,
});

function FinderRoute() {
  const answers = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const setAnswer = (key: keyof FinderAnswers, value: string) => {
    navigate({
      search: (prev: FinderAnswers) => ({
        ...prev,
        [key]: prev[key] === value ? "" : value,
      }),
      replace: true,
    });
  };

  const reset = () => navigate({ search: () => emptyAnswers, replace: true });

  return <CardFinder answers={answers} onAnswer={setAnswer} onReset={reset} />;
}
